import { useState, useCallback } from 'react';

export interface AlertMessage {
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

export const useAlert = () => {
  const [alertMessage, setAlertMessage] = useState<AlertMessage | null>(null);

  const showAlert = useCallback((alert: AlertMessage) => {
    setAlertMessage(alert);
  }, []);

  const hideAlert = useCallback(() => {
    setAlertMessage(null);
  }, []);

  const showSuccess = useCallback((message: string) => {
    setAlertMessage({ type: 'success', message });
  }, []);

  const showError = useCallback((message: string) => {
    setAlertMessage({ type: 'error', message });
  }, []);

  const showInfo = useCallback((message: string) => {
    setAlertMessage({ type: 'info', message });
  }, []);

  const showWarning = useCallback((message: string) => {
    setAlertMessage({ type: 'warning', message });
  }, []);

  return {
    alertMessage,
    showAlert,
    hideAlert,
    showSuccess,
    showError,
    showInfo,
    showWarning
  };
}; 